import { inject } from "vue";
/**
 * Provides injection of auth with TS type
 * Originataes from app.ts
 */
export function injectAppAuth() {
    const appAuth = inject("appAuth");
    return { appAuth };
}
/**
 * Provides injection of FederationConfig value with TS type
 * Originates from app.ts
 */
export function injectAppFederation() {
    const appFederation = inject("appFederation");
    return { appFederation };
}
/**
 * Provides injection of AppConfirm with TS type.
 * Originates from App.vue
 */
export function injectAppConfirm() {
    const appConfirm = inject("appConfirm");
    return { appConfirm };
}
/**
 * Provides injection of opening/closing snackbar with TS type.
 * Originates from App.vue
 */
export function injectSnackbar() {
    const snackbar = inject("snackbar");
    const snackbarClose = inject("snackbarClose");
    return {
        snackbar,
        snackbarClose
    };
}
/**
 * Provides injection of opening feedback in App.vue with TS type.
 * Originates from App.vue
 */
export function injectAppShowFeedback() {
    const appShowFeedback = inject("appShowFeedback");
    return {
        appShowFeedback
    };
}
/**
 * Provides injection of opening error state snackbar in App.vue with TS type.
 * Originates from App.vue
 */
export function injectSnackbarError() {
    const snackbarServerError = inject("snackbarServerError");
    return {
        snackbarServerError
    };
}
